import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';

const SearchTextInput = styled(TextField)({
  height: '40px'
});

interface SubmenuSearchProps {
  searchText: string;
  onChange: (e: any) => void;
}

export const SubmenuSearch = ({ searchText, onChange }: SubmenuSearchProps) => {
  return (
    <>
      <Divider />
      <Box sx={{ padding: '1rem' }}>
        <SearchTextInput
          data-testid='unified-inbox-quick-action-submenu-search'
          label='Search'
          type='search'
          variant='outlined'
          autoFocus={true}
          fullWidth
          onKeyDown={e => {
            e.stopPropagation();
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            )
          }}
          value={searchText}
          onChange={onChange}
        />
      </Box>
    </>
  );
};
